export default __webpack_public_path__ + "static/media/back-1.50936be3.png";